import { render, staticRenderFns } from "./PolizasAdministracionTabs.vue?vue&type=template&id=72d339b8&scoped=true&"
import script from "./PolizasAdministracionTabs.vue?vue&type=script&lang=js&"
export * from "./PolizasAdministracionTabs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72d339b8",
  null
  
)

export default component.exports